export default {
  SET_ACTION_TYPES(state, outcomes) {
    state.outcomes = outcomes
  },
  REMOVE_ACTION_TYPES(state, itemId) {
      const roleIndex = state.outcomes.datas.findIndex((u) => u.id == itemId)
      state.outcomes.datas.splice(roleIndex, 1)
  },
  SELECTED_ACTION_TYPES(state,data){
    state.outcomes.datas = []
    state.outcomes.total = 1;
    state.outcomes.per_page = 1;
    state.outcomes.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.outcome = data
  },
  ADD_ITEM(state,data){
    state.outcome = data
  },
}
